export default __webpack_public_path__ + "static/media/logo_branco.87203dc5.png";